import { render } from "./SizeGuideModal.vue?vue&type=template&id=3434103d"
import script from "./SizeGuideModal.vue?vue&type=script&lang=js"
export * from "./SizeGuideModal.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_6e4c079c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__